import { useState } from 'react';
import './bodyTeamCard.sass';

/**
 * BodyTeamCard - Componente optimizado para mostrar información de equipos
 * 
 * Muestra logo, sede, entrenador y posición con manejo de errores de imagen
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.data - Datos del equipo
 * @param {string} props.data.logo - URL del logo del equipo
 * @param {string} props.data.equipo - Nombre del equipo
 * @param {string} props.data.sede - Sede del equipo
 * @param {string} props.data.entrenador - Nombre del entrenador
 * @param {string} props.data.posicion - Posición o información adicional
 * 
 * @returns {JSX.Element} Tarjeta con información del equipo
 */
export default function BodyTeamCard({ data = {} }) {
  const { logo, equipo, sede, entrenador, posicion } = data;
  const [imageError, setImageError] = useState(false);

  /**
   * Componente para mostrar el logo con fallback
   */
  const TeamLogo = () => (
    <div className={`team-card__logo${imageError ? '-default' : ''}`}>
      {!imageError && logo && (
        <img
          src={logo}
          alt={equipo || 'Logo del equipo'}
          loading="lazy"
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );

  /**
   * Componente para mostrar una fila de información
   */
  const InfoRow = ({ label, value }) => {
    if (!value && !label) return null;
    
    return (
      <div className="team-card__info-row">
        <dt>{label}</dt>
        <dd>{value || '-'}</dd>
      </div>
    );
  };

  return (
    <div className="team-card__body">
      <TeamLogo />
      
      <dl className="team-card__info">
        <InfoRow label="SEDE:" value={sede} />
        <InfoRow label="Entrenador:" value={entrenador} />
        {posicion && (
          <div className="team-card__info-row team-card__position">
            <dt>{posicion}</dt>
          </div>
        )}
      </dl>
    </div>
  );
}